import { Component, EventEmitter, Input, OnChanges, Output } from '@angular/core';
import { HorizontalListData } from '../horizontal-list.model';
import { getSimpleHorizontalListWidgetConfigData } from './simple-horizontal-list-widget.data';
import { SimpleHorizontalListBgColorType, SimpleHorizontalListTitleSize, SimpleHorizontalListWidgetConfigData } from './simple-horizontal-list-widget.model';

@Component({
    selector: 'ifc-simple-horizontal-list-widget',
    templateUrl: './simple-horizontal-list-widget.component.html',
    styleUrls: ['./simple-horizontal-list-widget.component.scss'],
    standalone: false
})
export class SimpleHorizontalListWidgetComponent implements OnChanges {
  @Input()
  title?: string;

  @Input()
  listItems: HorizontalListData[];

  @Input()
  config?: SimpleHorizontalListWidgetConfigData;

  @Output()
  edit = new EventEmitter<void>();

  configData: SimpleHorizontalListWidgetConfigData;
  readonly BgColorType = SimpleHorizontalListBgColorType;
  readonly TitleSize = SimpleHorizontalListTitleSize;

  ngOnChanges(): void {
    this.configData = getSimpleHorizontalListWidgetConfigData(this.config);
  }

  onClickEdit(): void {
    this.edit.emit();
  }
}
